"use client";

import { useEffect } from "react";

import { ErrorState } from "@/components/error/ErrorState";

export default function AnonProtectedError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <ErrorState
      title="We could not load this area"
      description="A hiccup stopped us from showing the content you were after."
      details={
        <p>
          Give it another go. If it keeps failing, it might be a temporary outage on our end—our
          team gets alerted to these and jumps on them quickly.
        </p>
      }
      actions={[
        {
          label: "Try again",
          onClick: () => reset(),
        },
        {
          label: "Go to home",
          href: "/",
          variant: "ghost",
        },
      ]}
    />
  );
}
